<!-- @format -->

<template>
  <div class="heade" ref="bindIndex">
    <div class="headecon" :style="{ width: operatewidth + 'px' }">
      <div class="logobox" @click="gobackindex" style="position:relative">
        <i v-if="yishengyice" class="iconfont icon_logoyishengyice" style="font-size:130px;color:#3B80FB;position:absolute;top:-82px"></i>
        <i v-else class="iconfont icon_logo" style="font-size:130px;color:#3B80FB;position:absolute;top:-82px"></i>
      </div>

      <div v-if="linkflag" style="display: flex; align-items: center">
        <ul class="navcon">
          <li v-show="resume_show" @click="selectnav(0)" :class="{ active: current === 0 }">简历</li>
          <li @click="selectnav(1)" :class="{ active: current === 1  }">职位</li>
        </ul>

        <div class="textbox" style="border-radius: 20px; border: 1px solid #3b80fb; color: #e5e5e5" @click="outlogin">
          <p>退出登录</p>
        </div>
      </div>

      <Poptip trigger="hover" width="253" v-else>
        <div class="textbox textbox2">
          <p>联系我们</p>
        </div>

        <div slot="content">
          <div class="context">
            <img style="height: 24px; width: 24px" src="@/assets/qiye_small.png" alt="" />
            <div style="display: flex; margin-left: 10px">
              <p style="color: #666; font-size: 18px">企业：</p>
              <p style="color: #333; font-size: 18px">18916565974</p>
            </div>
          </div>
          <div class="context">
            <img style="height: 24px; width: 24px" src="@/assets/xusheng_small.png" alt="" />
            <div style="display: flex; margin-left: 10px">
              <p style="color: #666; font-size: 18px">学生：</p>
              <p style="color: #333; font-size: 18px">021-66696957</p>
            </div>
          </div>
          <div class="context">
            <img style="height: 24px; width: 24px" src="@/assets/gaoxiao_small.png" alt="" />
            <div style="display: flex; margin-left: 10px">
              <p style="color: #666; font-size: 18px">高校：</p>
              <p style="color: #333; font-size: 18px">18618362798</p>
            </div>
          </div>
        </div>
      </Poptip>

      <Modal class-name="heademod" v-model="openzhi" width="724px">
        <div style="height: 100%; width: 100%; display: flex">
          <div class="contentleft">
            <p style="margin-bottom: 30px; font-size: 14px; color: #666666">
              程序员哥哥正在抓紧开发PC站点～
            </p>
            <img style="height: 231px; width: 283px" src="@/assets/zhiwei_kaifa.png" alt="" />
          </div>
          <div class="contentright">
            <p style="margin-bottom: 30px; font-size: 14px; color: #333">
              海量职位请用微信扫码访问
            </p>
            <img v-if="yishengyice" style="height: 234px; width: 234px" src="@/assets/erweima2_ysyc.png" alt="" />
            <img v-else style="height: 234px; width: 234px" src="@/assets/zhiwei.png" alt="" />
          </div>
        </div>
        <div slot="footer"></div>
      </Modal>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
export default {
  name: 'Heade',
  props: {
    yishengyice: Boolean
  },
  data() {
    return {
      resume_show: true,
      current: 0,
      openzhi: false,
      linkflag: false,
      operatewidth: 1000
    }
  },

  created() {
    if (/resume/g.test(window.location.href)) {
      this.linkflag = true
    } else {
      this.current = 3
    }
    if (/resume_add|resume_create/g.test(window.location.href)) {
      ;(this.current = 3), (this.linkflag = true)
    }
  },
  watch: {
    // 监听 this.$route.path     watch监听非DOM元素的改变
    '$route.path': function(newVal) {
      const navArr = ['/resume_add', '/resume_create']
      this.resume_show = !navArr.includes(newVal)
      if (navArr.includes(newVal) || newVal === '/resume') {
        this.$refs.bindIndex.style.background = '#182b4e'
        this.operatewidth = 1200
        this.linkflag = true
      } else {
        this.$refs.bindIndex.style.background = '#fff'
        this.operatewidth = 1000
        this.linkflag = false
      }
      if (newVal !== '/resume') {
        this.current = 3
      } else {
        this.current = 0
      }
    }
  },

  methods: {
    gobackindex() {
      this.$router.push({ path: '/' })
    },
    outlogin() {
      this.$Modal.confirm({
        title: '提示',
        content: '是否确定退出？',
        onOk: () => {
          Cookies.set('user_id', '')
          localStorage.removeItem('resume_parse')
          this.$router.push({ path: '/login' })
        }
      })
    },
    selectnav(index) {
      if (index === 0) {
        if (/resume/g.test(window.location.href)) {
          this.current = 0
        }
        this.$router.push({ path: '/resume' })
      } else if (index == '1') {
        this.openzhi = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.heade {
  height: 100%;
  display: flex;
  justify-content: center;
  /* background: #182b4e; */
  /* border-bottom: 1px solid #e2e2e2ff; */
}

.headecon {
  width: 1200px;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.logobox {
  height: 31px;
  width: 259px;
}

.textbox {
  height: 38px;
  width: 96px;
  line-height: 38px;
  text-align: center;
  /* background: #ecf2fd; */
  border-radius: 19px;
  cursor: pointer;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #3b80fb;
}

.textbox2 {
  background: #edf3ff;
}

.textbox2:hover {
  background: #3b80fb;
  color: #fff;
  transition: all 0.6s;
}

.textbox:hover {
  background: #3b80fb;
  color: #fff;
  transition: all 0.6s;
}

.context {
  width: 100%;
  display: flex;
  align-items: center;
}

.navcon {
  margin-right: 60px;
  display: flex;
  height: 100%;
}
.navcon li {
  list-style-type: none;
  height: 100%;
  line-height: 50px;
  margin-right: 50px;
  cursor: pointer;
  font-size: 16px;
  color: #e5e5e5;
  /* color:#fff; */
}

.active {
  border-bottom: 3px solid #4f8eff;
  /* color: #4f8eff !important; */
  color: #fff !important;
  font-weight: bold;
}

.contentleft {
  height: 100%;
  width: 362px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px 0px 0px 8px;
  background: #edf3ff;
}

.contentright {
  height: 100%;
  width: 362px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 0px 8px 8px 0px;
  background: #fff;
}
</style>

<style>
.heademod .ivu-modal-footer {
  border-top: 0;
}

.heademod .ivu-modal-content {
  height: 406px;
  width: 724px;
}

.heademod .ivu-modal-body {
  height: 100%;
  width: 100%;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/public/header.vue